import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'financialYearPeriodType',
    pure: false
})
export class FinancialYearPeriodTypePipe implements PipeTransform {
    constructor(private translateService: TranslateService) { }

    transform(value: string | undefined): string {
        if (!value) {
            return '-';
        }

        const translationKey = `FINANCIALYEAR.PERIOD_TYPE.${value.toUpperCase()}`;
        const translatedValue = this.translateService.instant(translationKey);

        // Fallback to original value if translation not found
        return translatedValue === translationKey ? value : translatedValue;
    }
}
